import React, { FunctionComponent, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import StepConnector from '@material-ui/core/StepConnector';
import styled from 'styled-components';
import { IntlShape, injectIntl } from 'react-intl';
import { getSteps, setActiveStepper } from 'containers/AppContainer/utils';
import { history } from 'store';
import { COLORS } from 'constants/design';

const StyledStepper = styled(Stepper)`
  &&.root {
    width: 100%;
    background-color: rgba(0, 0, 255, 0);
  }
`;

const StyledStepConnector = withStyles({
  active: {
    '& $line': {
      borderColor: `${COLORS.BLUE}`,
    },
  },
  completed: {
    '& $line': {
      borderColor: `${COLORS.JUNGLE_GREEN}`,
    },
  },
  line: {
    height: 1,
    borderWidth: 1.25,
    borderStyle: 'solid',
  },
  lineHorizontal: {
    margin: '0 -7px',
  },
})(StepConnector);

const StyledStepLabel = styled(StepLabel)`
  .MuiStepIcon-root {
    width: 26px;
    height: 26px;
    position: relative;
    z-index: 99;
  }
  .MuiStepIcon-completed {
    color: ${COLORS.JUNGLE_GREEN};
  }
  .MuiStepLabel-label.MuiStepLabel-active {
    color: ${COLORS.TEXT_BLACK} !important;
    fontweight: bold;
  }
  .MuiStepLabel-label {
    color: ${COLORS.SECONDARY_SILVER} !important;
  }
  .MuiStepLabel-label.MuiStepLabel-completed {
    color: ${COLORS.TEXT_BLUE} !important;
    fontweight: bold;
  }
`;

const StepperContainer = styled.div`
  position: sticky;
  margin-top: -40px;
  z-index: 9999;
  width: 80%;
  top: 25px;
`;

export interface StepperBarProps {
  intl: IntlShape;
  isOpeningManager?: boolean;
  isPreOpeningManager?: boolean;
  isBasicManagement?: boolean;
  isCourtManager?: boolean;
}

const StepperBar: FunctionComponent<StepperBarProps> = (props): JSX.Element => {
  const [activeStep, setActiveStep] = React.useState(0);
  const steps = getSteps(props);
  useEffect(() => {
    setActiveStepper(props, history, setActiveStep);
  }, [props]);
  return (
    <StepperContainer>
      <StyledStepper
        className="root"
        alternativeLabel
        activeStep={activeStep}
        connector={<StyledStepConnector />}
      >
        {steps.map((label, index) => (
          <Step key={index}>
            <StyledStepLabel>{label}</StyledStepLabel>
          </Step>
        ))}
      </StyledStepper>
    </StepperContainer>
  );
};

export default injectIntl(StepperBar);
